/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BarrierCategoryEditor_barrierSourceTypeConfigs$ref = any;
type BarrierCategoryEditor_list$ref = any;
type BarrierSourceTypeEditor_barrierSourceDetailConfigs$ref = any;
type BarrierSourceTypeEditor_barrierSourceTypeConfigs$ref = any;
type BoardTemplateRowList_list$ref = any;
type CodeTableEditor_list$ref = any;
type VisibilityBoardAddressRowList_list$ref = any;
type VisibilityBoardRowList_list$ref = any;
export type CodeType = "BarrierCategory" | "BarrierEscalationRole" | "BarrierNeedsReassignmentReason" | "BarrierSourceDetail" | "BundledPaymentType" | "CareTeamMemberRole" | "Condition" | "DeliveryMethod" | "PlanCategory" | "WorkingDischargeDisposition" | "%future added value";
export type AdminPageQueryVariables = {|
  ct1: CodeType,
  ct5: CodeType,
  ct6: CodeType,
  ct7: CodeType,
  ct8: CodeType,
  ct9: CodeType,
  barrierSourceDetail: CodeType,
|};
export type AdminPageQueryResponse = {|
  +facilities: $ReadOnlyArray<{|
    +exchangeName: string,
    +name: string,
    +departments: {|
      +nodes: ?$ReadOnlyArray<{|
        +exchangeName: string,
        +name: string,
        +beds: {|
          +nodes: $ReadOnlyArray<{|
            +exchangeName: string,
            +name: string,
          |}>
        |},
      |}>
    |},
  |}>,
  +visibilityBoardAddresses: ?$ReadOnlyArray<?{|
    +$fragmentRefs: VisibilityBoardAddressRowList_list$ref
  |}>,
  +visibilityBoardsList: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>,
  +visibilityBoards: ?$ReadOnlyArray<?{|
    +$fragmentRefs: VisibilityBoardRowList_list$ref
  |}>,
  +templatesList: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>,
  +boardTemplates: ?$ReadOnlyArray<?{|
    +$fragmentRefs: BoardTemplateRowList_list$ref
  |}>,
  +conditions: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +barrierCategories: ?$ReadOnlyArray<?{|
    +$fragmentRefs: BarrierCategoryEditor_list$ref
  |}>,
  +careTeamMemberRoles: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +planCategories: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +workingDischargeDispositions: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +barrierNeedsReassignmentReasons: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +deliveryMethods: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
  +barrierSourceTypes: ?$ReadOnlyArray<?{|
    +$fragmentRefs: BarrierSourceTypeEditor_barrierSourceTypeConfigs$ref
  |}>,
  +barrierSourceTypesForBarCat: ?$ReadOnlyArray<?{|
    +$fragmentRefs: BarrierCategoryEditor_barrierSourceTypeConfigs$ref
  |}>,
  +barrierSourceDetailsForBarSrcType: ?$ReadOnlyArray<?{|
    +$fragmentRefs: BarrierSourceTypeEditor_barrierSourceDetailConfigs$ref
  |}>,
  +barrierSourceDetails: ?$ReadOnlyArray<?{|
    +$fragmentRefs: CodeTableEditor_list$ref
  |}>,
|};
export type AdminPageQuery = {|
  variables: AdminPageQueryVariables,
  response: AdminPageQueryResponse,
|};
*/


/*
query AdminPageQuery(
  $ct1: CodeType!
  $ct5: CodeType!
  $ct6: CodeType!
  $ct7: CodeType!
  $ct8: CodeType!
  $ct9: CodeType!
  $barrierSourceDetail: CodeType!
) {
  facilities {
    exchangeName
    name
    departments(first: 10000) {
      nodes {
        exchangeName
        name
        beds(first: 10000) {
          nodes {
            exchangeName
            name
            id
          }
        }
        id
      }
    }
    id
  }
  visibilityBoardAddresses {
    ...VisibilityBoardAddressRowList_list
    id
  }
  visibilityBoardsList: visibilityBoards {
    id
    name
  }
  visibilityBoards {
    ...VisibilityBoardRowList_list
    id
  }
  templatesList: boardTemplates {
    id
    name
  }
  boardTemplates {
    ...BoardTemplateRowList_list
    id
  }
  conditions: codeTables(codeTableType: $ct1) {
    ...CodeTableEditor_list
    id
  }
  barrierCategories {
    ...BarrierCategoryEditor_list
    id
  }
  careTeamMemberRoles: codeTables(codeTableType: $ct5) {
    ...CodeTableEditor_list
    id
  }
  planCategories: codeTables(codeTableType: $ct6) {
    ...CodeTableEditor_list
    id
  }
  workingDischargeDispositions: codeTables(codeTableType: $ct7) {
    ...CodeTableEditor_list
    id
  }
  barrierNeedsReassignmentReasons: codeTables(codeTableType: $ct8) {
    ...CodeTableEditor_list
    id
  }
  deliveryMethods: codeTables(codeTableType: $ct9) {
    ...CodeTableEditor_list
    id
  }
  barrierSourceTypes {
    ...BarrierSourceTypeEditor_barrierSourceTypeConfigs
    id
  }
  barrierSourceTypesForBarCat: barrierSourceTypes {
    ...BarrierCategoryEditor_barrierSourceTypeConfigs
    id
  }
  barrierSourceDetailsForBarSrcType: codeTables(codeTableType: $barrierSourceDetail) {
    ...BarrierSourceTypeEditor_barrierSourceDetailConfigs
    id
  }
  barrierSourceDetails: codeTables(codeTableType: $barrierSourceDetail) {
    ...CodeTableEditor_list
    id
  }
}

fragment BarrierCategoryEditor_barrierSourceTypeConfigs on BarrierSourceType {
  id
  code
  value
  ordinal
  active
  activeDirectorySourceName
}

fragment BarrierCategoryEditor_list on BarrierCategory {
  ...BarrierCategoryTable_list
  ordinal
}

fragment BarrierCategoryTable_list on BarrierCategory {
  id
  code
  value
  ordinal
  active
  sourceTypes {
    id
    code
    value
    active
  }
}

fragment BarrierSourceTypeEditor_barrierSourceDetailConfigs on CodeTable {
  id
  code
  value
  ordinal
  active
}

fragment BarrierSourceTypeEditor_barrierSourceTypeConfigs on BarrierSourceType {
  ...BarrierSourceTypeTable_barrierSourceTypeConfigs
  ordinal
}

fragment BarrierSourceTypeTable_barrierSourceTypeConfigs on BarrierSourceType {
  id
  code
  value
  ordinal
  active
  activeDirectorySourceName
  hasConfiguredList
  sourceDetails {
    code
    value
    active
    ordinal
    id
  }
}

fragment BoardTemplateRowList_list on BoardTemplate {
  ...BoardTemplateRow_rowData
}

fragment BoardTemplateRow_rowData on BoardTemplate {
  id
  name
  boardType
  description
  template
  columns {
    field
  }
}

fragment CodeTableEditor_list on CodeTable {
  ...CodeTableRowList_list
  ordinal
}

fragment CodeTableRowList_list on CodeTable {
  ...CodeTableRow_rowData
}

fragment CodeTableRow_rowData on CodeTable {
  id
  code
  value
  ordinal
  active
}

fragment VisibilityBoardAddressRowList_list on VisibilityBoardAddress {
  ...VisibilityBoardAddressRow_rowData
}

fragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {
  id
  address
  description
  visibilityBoard {
    id
    name
  }
}

fragment VisibilityBoardRowList_list on VisibilityBoard {
  ...VisibilityBoardRow_rowData
}

fragment VisibilityBoardRow_rowData on VisibilityBoard {
  id
  name
  description
  boardTemplate {
    id
    name
  }
  departmentExchangeName
  bedExchangeNames
  footer
  scrollDuration
  timeHeaderFormat
  locationStatusesDisplay
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "barrierSourceDetail"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct1"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct5"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct6"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct7"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct8"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ct9"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  (v8/*: any*/)
],
v12 = {
  "alias": "visibilityBoardsList",
  "args": null,
  "concreteType": "VisibilityBoard",
  "kind": "LinkedField",
  "name": "visibilityBoards",
  "plural": true,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": "templatesList",
  "args": null,
  "concreteType": "BoardTemplate",
  "kind": "LinkedField",
  "name": "boardTemplates",
  "plural": true,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct1"
  }
],
v15 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "CodeTableEditor_list"
  }
],
v16 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct5"
  }
],
v17 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct6"
  }
],
v18 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct7"
  }
],
v19 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct8"
  }
],
v20 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "ct9"
  }
],
v21 = [
  {
    "kind": "Variable",
    "name": "codeTableType",
    "variableName": "barrierSourceDetail"
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v27 = [
  (v10/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeDirectorySourceName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facilities",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "DepartmentConnection",
            "kind": "LinkedField",
            "name": "departments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "BedConnection",
                    "kind": "LinkedField",
                    "name": "beds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Bed",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "beds(first:10000)"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "departments(first:10000)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddress",
        "kind": "LinkedField",
        "name": "visibilityBoardAddresses",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VisibilityBoardAddressRowList_list"
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoard",
        "kind": "LinkedField",
        "name": "visibilityBoards",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VisibilityBoardRowList_list"
          }
        ],
        "storageKey": null
      },
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardTemplate",
        "kind": "LinkedField",
        "name": "boardTemplates",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BoardTemplateRowList_list"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "conditions",
        "args": (v14/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierCategory",
        "kind": "LinkedField",
        "name": "barrierCategories",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BarrierCategoryEditor_list"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "careTeamMemberRoles",
        "args": (v16/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": "planCategories",
        "args": (v17/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": "workingDischargeDispositions",
        "args": (v18/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": "barrierNeedsReassignmentReasons",
        "args": (v19/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": "deliveryMethods",
        "args": (v20/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierSourceType",
        "kind": "LinkedField",
        "name": "barrierSourceTypes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BarrierSourceTypeEditor_barrierSourceTypeConfigs"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "barrierSourceTypesForBarCat",
        "args": null,
        "concreteType": "BarrierSourceType",
        "kind": "LinkedField",
        "name": "barrierSourceTypes",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BarrierCategoryEditor_barrierSourceTypeConfigs"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "barrierSourceDetailsForBarSrcType",
        "args": (v21/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BarrierSourceTypeEditor_barrierSourceDetailConfigs"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "barrierSourceDetails",
        "args": (v21/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facilities",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "DepartmentConnection",
            "kind": "LinkedField",
            "name": "departments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "BedConnection",
                    "kind": "LinkedField",
                    "name": "beds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Bed",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "beds(first:10000)"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "departments(first:10000)"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddress",
        "kind": "LinkedField",
        "name": "visibilityBoardAddresses",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VisibilityBoard",
            "kind": "LinkedField",
            "name": "visibilityBoard",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoard",
        "kind": "LinkedField",
        "name": "visibilityBoards",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v8/*: any*/),
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BoardTemplate",
            "kind": "LinkedField",
            "name": "boardTemplate",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "departmentExchangeName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bedExchangeNames",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "footer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scrollDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeHeaderFormat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locationStatusesDisplay",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "BoardTemplate",
        "kind": "LinkedField",
        "name": "boardTemplates",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boardType",
            "storageKey": null
          },
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "template",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BoardColumnConfig",
            "kind": "LinkedField",
            "name": "columns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "conditions",
        "args": (v14/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierCategory",
        "kind": "LinkedField",
        "name": "barrierCategories",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BarrierSourceType",
            "kind": "LinkedField",
            "name": "sourceTypes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "careTeamMemberRoles",
        "args": (v16/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "planCategories",
        "args": (v17/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "workingDischargeDispositions",
        "args": (v18/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "barrierNeedsReassignmentReasons",
        "args": (v19/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "deliveryMethods",
        "args": (v20/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BarrierSourceType",
        "kind": "LinkedField",
        "name": "barrierSourceTypes",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasConfiguredList",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BarrierSourceDetail",
            "kind": "LinkedField",
            "name": "sourceDetails",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v25/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "barrierSourceTypesForBarCat",
        "args": null,
        "concreteType": "BarrierSourceType",
        "kind": "LinkedField",
        "name": "barrierSourceTypes",
        "plural": true,
        "selections": [
          (v10/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "barrierSourceDetailsForBarSrcType",
        "args": (v21/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      },
      {
        "alias": "barrierSourceDetails",
        "args": (v21/*: any*/),
        "concreteType": "CodeTable",
        "kind": "LinkedField",
        "name": "codeTables",
        "plural": true,
        "selections": (v27/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e852b1a83bf4559bc610195b58e68856",
    "id": null,
    "metadata": {},
    "name": "AdminPageQuery",
    "operationKind": "query",
    "text": "query AdminPageQuery(\n  $ct1: CodeType!\n  $ct5: CodeType!\n  $ct6: CodeType!\n  $ct7: CodeType!\n  $ct8: CodeType!\n  $ct9: CodeType!\n  $barrierSourceDetail: CodeType!\n) {\n  facilities {\n    exchangeName\n    name\n    departments(first: 10000) {\n      nodes {\n        exchangeName\n        name\n        beds(first: 10000) {\n          nodes {\n            exchangeName\n            name\n            id\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  visibilityBoardAddresses {\n    ...VisibilityBoardAddressRowList_list\n    id\n  }\n  visibilityBoardsList: visibilityBoards {\n    id\n    name\n  }\n  visibilityBoards {\n    ...VisibilityBoardRowList_list\n    id\n  }\n  templatesList: boardTemplates {\n    id\n    name\n  }\n  boardTemplates {\n    ...BoardTemplateRowList_list\n    id\n  }\n  conditions: codeTables(codeTableType: $ct1) {\n    ...CodeTableEditor_list\n    id\n  }\n  barrierCategories {\n    ...BarrierCategoryEditor_list\n    id\n  }\n  careTeamMemberRoles: codeTables(codeTableType: $ct5) {\n    ...CodeTableEditor_list\n    id\n  }\n  planCategories: codeTables(codeTableType: $ct6) {\n    ...CodeTableEditor_list\n    id\n  }\n  workingDischargeDispositions: codeTables(codeTableType: $ct7) {\n    ...CodeTableEditor_list\n    id\n  }\n  barrierNeedsReassignmentReasons: codeTables(codeTableType: $ct8) {\n    ...CodeTableEditor_list\n    id\n  }\n  deliveryMethods: codeTables(codeTableType: $ct9) {\n    ...CodeTableEditor_list\n    id\n  }\n  barrierSourceTypes {\n    ...BarrierSourceTypeEditor_barrierSourceTypeConfigs\n    id\n  }\n  barrierSourceTypesForBarCat: barrierSourceTypes {\n    ...BarrierCategoryEditor_barrierSourceTypeConfigs\n    id\n  }\n  barrierSourceDetailsForBarSrcType: codeTables(codeTableType: $barrierSourceDetail) {\n    ...BarrierSourceTypeEditor_barrierSourceDetailConfigs\n    id\n  }\n  barrierSourceDetails: codeTables(codeTableType: $barrierSourceDetail) {\n    ...CodeTableEditor_list\n    id\n  }\n}\n\nfragment BarrierCategoryEditor_barrierSourceTypeConfigs on BarrierSourceType {\n  id\n  code\n  value\n  ordinal\n  active\n  activeDirectorySourceName\n}\n\nfragment BarrierCategoryEditor_list on BarrierCategory {\n  ...BarrierCategoryTable_list\n  ordinal\n}\n\nfragment BarrierCategoryTable_list on BarrierCategory {\n  id\n  code\n  value\n  ordinal\n  active\n  sourceTypes {\n    id\n    code\n    value\n    active\n  }\n}\n\nfragment BarrierSourceTypeEditor_barrierSourceDetailConfigs on CodeTable {\n  id\n  code\n  value\n  ordinal\n  active\n}\n\nfragment BarrierSourceTypeEditor_barrierSourceTypeConfigs on BarrierSourceType {\n  ...BarrierSourceTypeTable_barrierSourceTypeConfigs\n  ordinal\n}\n\nfragment BarrierSourceTypeTable_barrierSourceTypeConfigs on BarrierSourceType {\n  id\n  code\n  value\n  ordinal\n  active\n  activeDirectorySourceName\n  hasConfiguredList\n  sourceDetails {\n    code\n    value\n    active\n    ordinal\n    id\n  }\n}\n\nfragment BoardTemplateRowList_list on BoardTemplate {\n  ...BoardTemplateRow_rowData\n}\n\nfragment BoardTemplateRow_rowData on BoardTemplate {\n  id\n  name\n  boardType\n  description\n  template\n  columns {\n    field\n  }\n}\n\nfragment CodeTableEditor_list on CodeTable {\n  ...CodeTableRowList_list\n  ordinal\n}\n\nfragment CodeTableRowList_list on CodeTable {\n  ...CodeTableRow_rowData\n}\n\nfragment CodeTableRow_rowData on CodeTable {\n  id\n  code\n  value\n  ordinal\n  active\n}\n\nfragment VisibilityBoardAddressRowList_list on VisibilityBoardAddress {\n  ...VisibilityBoardAddressRow_rowData\n}\n\nfragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {\n  id\n  address\n  description\n  visibilityBoard {\n    id\n    name\n  }\n}\n\nfragment VisibilityBoardRowList_list on VisibilityBoard {\n  ...VisibilityBoardRow_rowData\n}\n\nfragment VisibilityBoardRow_rowData on VisibilityBoard {\n  id\n  name\n  description\n  boardTemplate {\n    id\n    name\n  }\n  departmentExchangeName\n  bedExchangeNames\n  footer\n  scrollDuration\n  timeHeaderFormat\n  locationStatusesDisplay\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7b1937618aa4cc976bcdf6c8fd53bbdf';

module.exports = node;
